import { NewCurrencyChipFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { ChainChipFragment } from "@/components/chains/ChainChip/ChainChip.fragment"
import { CollectionCurrencyPreviewFragment } from "@/components/currencies/CollectionCurrencyPreview/CollectionCurrencyPreview.fragment"

export const CurrencyMetadataChipsFragment = graphql(
  `
    fragment CurrencyMetadataChips on Currency {
      symbol
      chain {
        ...ChainChip
      }
      ...CollectionCurrencyPreview
      ...NewCurrencyChip
    }
  `,
  [
    ChainChipFragment,
    CollectionCurrencyPreviewFragment,
    NewCurrencyChipFragment,
  ],
)
